import React from 'react';
import { group } from '../mock';
import SectionHeader from './SectionHeader';
import { ArrowUpRight } from 'lucide-react';

export default function GroupSection() {
  const [first, second, ...rest] = group.cards;
  return (
    <section id="group" className="py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          kicker={group.kicker}
          title={group.title}
          description={group.description}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          <Card card={first} large />
          <Card card={second} large />
        </div>

        <div className="mt-5 md:mt-6 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {rest.map((c) => (
            <Card key={c.n} card={c} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ card, large }) {
  return (
    <a
      href={card.href}
      target="_blank"
      rel="noreferrer"
      className="group block border border-neutral-900 hover:border-[#ED2D5C]/60 bg-[#0d0d0d] hover:bg-[#111] p-7 md:p-9 transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <p className="mono text-[10px] md:text-[11px] tracking-[0.22em] text-neutral-500">
          {card.n} / {card.tag.toUpperCase()}
        </p>
        <ArrowUpRight
          size={18}
          className="text-neutral-500 group-hover:text-[#ED2D5C] transition-colors"
        />
      </div>
      <h3
        className={`font-display text-white mt-6 md:mt-10 ${
          large
            ? 'text-[34px] md:text-[44px] lg:text-[56px]'
            : 'text-[28px] md:text-[32px]'
        } leading-[0.95]`}
      >
        {card.name}
      </h3>
      <p className="mt-5 md:mt-6 text-neutral-400 text-[14px] md:text-[15px] leading-relaxed max-w-[440px]">
        {card.body}
      </p>
    </a>
  );
}
